import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Typography from '@material-ui/core/Typography';
import ListIcon from '@material-ui/icons/List';
import { withStyles } from '@material-ui/core/styles';
import { LoadingOverlayWrapper } from 'components/layout';

const QueueIndex = ({ classes, queueBinsState, isFetchingQueueTxnOppsData }) => {
  const myTasksCount = queueBinsState?.allTasks.openTasksLength() ?? 0;
  const completedCount = queueBinsState?.allTasks.completedTasksLength() ?? 0;
  const count = myTasksCount + completedCount;
  return (
    <LoadingOverlayWrapper
      className={classes.loadingOverlayQueue}
      active={isFetchingQueueTxnOppsData}
      message={"Loading opps..."}
    >
      <div className={classes.container}>
        <div className={classes.queueIndexGrid}>
          <div className={classes.headerTextContainer}>
            <Typography className={classes.text} >
              <ListIcon className={classes.icon} fontSize='large' />
              {count + ' total items in Queue'}
            </Typography>
          </div>
          <div className={classes.subTextContainer}>
            <Typography className={classes.subText} >{myTasksCount + ' My Opps'}</Typography>
            <Typography className={classes.subText} >{completedCount + ' Completed'}</Typography>
          </div>
        </div>
      </div>
    </LoadingOverlayWrapper>
  )
};

const styles = {
  container: {
    display: 'flex',
    height: '100%',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  icon: {
    margin: '0px 10px 0px 0px',
    verticalAlign: 'middle'
  },
  text: {
    fontSize: '1.9rem',
    color: 'gray',
    borderBottom: '3px solid lightgray'
  },
  subText: {
    fontSize: '1.5rem',
    color: 'gray',
  },
  subTextContainer: {
    textAlign: 'left',
  },
  queueIndexGrid: {
    display: 'grid',
  },
  headerTextContainer: {
    textAlign: 'center',
  },
  loadingOverlayQueue: {
    width: 'calc(100% - 380px)',
    height: '100%',
    marginLeft: 380
  }
}

const mapStateToProps = state => ({
  queueBinsState: state.queueState.underwrite.queueBinsState,
  isFetchingQueueTxnOppsData: state.queueState.underwrite.isFetchingQueueTxnOppsData,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(QueueIndex);